import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Layout } from 'antd';
import React from 'react';
import { useDispatch } from 'react-redux';
import { SidebarActions } from '../../../../libs/store/actions/SidebarActions';
import { IApplicationState, useAppSelector } from '../../../../libs/store/reducers';
import { useViewMode } from '../../../../contexts/ViewModeContext';
import ModeToggle from '../../../ai/ModeToggle/ModeToggle';
import OverviewHeader from './OverviewHeader/OverviewHeader';
import CapabilitySearch from './CapabilitySearch/CapabilitySearch';
import './AppHeaderStyles.less';

const { Header } = Layout;

interface IAppHeaderProps {
  isScrolled: boolean;
}

const AppHeader = ({ isScrolled }: IAppHeaderProps) => {
  const dispatch = useDispatch();
  const { mode, setMode } = useViewMode();

  const { isExpanded } = useAppSelector((state: IApplicationState) => ({
    isExpanded: state.sidebar.isExpanded,
  }));

  const dispatcher = {
    toggleSidebar: (data: boolean) => dispatch(SidebarActions.toggleSidebar(data)),
  };

  const toggleSidebar = () => dispatcher.toggleSidebar(!isExpanded);

  return (
    <Header className={`app-header-container${isScrolled ? '-bottom-border' : ''}`}>
      <Button
        onClick={toggleSidebar}
        type="primary"
        className="sidebar-toggle-button"
        size="middle"
      >
        {isExpanded ? (
          <LeftOutlined className="sidebar-trigger" />
        ) : (
          <RightOutlined className="sidebar-trigger" />
        )}
      </Button>
      <div className="app-header-content">
        <div className="app-header-search">
          <CapabilitySearch />
        </div>
        <div className="app-header-mode-toggle">
          <ModeToggle value={mode} onChange={setMode} />
        </div>
        <div className="app-header-overview">
          <OverviewHeader />
        </div>
      </div>
    </Header>
  );
};

export default AppHeader;

